import React, { Component } from 'react';
import {Button, Form, Input} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import "../css/CCEmail.css"

class CCEmail extends Component{
    render() {
        return <div className="spaceBox spaceHeaderBox cc_Email">
            <Form.Item
                label="Email Address"
                name={'ccEmailAddress'}
                rules={[{ required: false }]}
            >
                <Input maxLength={200} />
            </Form.Item>
            <Form.List name="template3">
                {(fields, { add, remove }) => (
                    <>
                        <Form.Item
                            className={'addFormBtn'}
                            label="CC Email"
                        >
                            <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                            </Button>
                        </Form.Item>
                        {fields.map(({ key, name, fieldKey, field, index, ...restField }) => (
                            <Form.Item
                                label="Email Address"
                                {...restField}
                                name={[name, 'ccEmailAddress']}
                                fieldKey={[fieldKey, 'ccEmailAddress']}
                                rules={[{ required: false }]}
                            >
                                <Input maxLength={200} style={{padding:'auto'}} suffix={<MinusCircleOutlined onClick={() => remove(name)} />}/>

                            </Form.Item>

                        ))}
                    </>
                )}
            </Form.List>
        </div>
    }
}

export default CCEmail;